<div class="p-5">
  <!-- Report Cards Grid -->
  <div class="grid grid-cols-1 min-[800px]:grid-cols-2 min-[1200px]:grid-cols-3 gap-6">
    <!-- Row 1 - Card 1 -->
    <div
      class="flex flex-row items-center border border-gray-300 rounded-lg bg-white p-4 gap-4 pl-0 dashboard-card shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-200 min-h-[calc(15vh-1.5rem)]"
    >
      <div class="report-icon-wrapper">
        <img src="images/reports/laptop_icon.svg" alt="Report 1" style="height: 150px !important; width: 150px !important; transform: translateY(-50%) translateX(-45%);" class="report-icon" />
      </div>
      <div class="flex flex-col h-full w-full justify-between border-l border-gray-300 pl-4">
        <div>
          <h4 class="!text-[18px] text-gray-400 mb-1">Single device usage report</h4>
          <p class="text-sm text-gray-600">
            Generate a report for a single device. See all relevant data for the device such as recent users, user sessions, telemetry data, and more.
          </p>
        </div>
        <div class="flex justify-end">
          <button
            class="!text-[14px] text-tertiary-blue-cta hover:bg-blue-50 border border-blue-600 rounded-md px-8 py-1 text-sm transition"
            type="button"
            (click)="openSingleDeviceSearchPanel()"
          >
            See Report
          </button>
        </div>
      </div>
    </div>

    <!-- Row 1 - Card 2 -->
    <div
      class="flex flex-row items-center border border-gray-300 rounded-lg bg-white p-4 gap-4 pl-0 dashboard-card shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-200 min-h-[calc(15vh-1.5rem)]"
    >
      <div class="report-icon-wrapper">
        <img src="images/reports/student_icon.svg" alt="Report 2" style="height: 90px !important; width: 90px !important; transform: translateY(-50%) translateX(-11%);" class="report-icon" />
      </div>
      <div class="flex flex-col h-full w-full justify-between border-l border-gray-300 pl-4">
        <div>
          <h4 class="!text-[18px] text-gray-400 mb-1">Single user report</h4>
          <p class="text-sm text-gray-600">
            Generate a report for a single user by email address. See data for the user such as user OU, Gopher Buddy sessions, and more.
          </p>
        </div>
        <div class="flex justify-end">
          <button
            class="!text-[14px] text-tertiary-blue-cta hover:bg-blue-50 border border-blue-600 rounded-md px-8 py-1 text-sm transition"
            type="button"
            (click)="openSingleUserSearchPanel()"
          >
            See Report
          </button>
        </div>
      </div>
    </div>

    <!-- Row 1 - Card 3 -->
    <div
      class="flex flex-row items-center border border-gray-300 rounded-lg bg-white p-4 gap-4 pl-0 dashboard-card shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-200 min-h-[calc(15vh-1.5rem)]"
    >
      <div class="report-icon-wrapper">
        <img src="images/reports/download_laptop.svg" alt="Report 3" style="height: 100px !important; width: 100px !important; transform: translateY(-50%) translateX(-10%);" class="report-icon" />
      </div>
      <div class="flex flex-col h-full w-full justify-between border-l border-gray-300 pl-4">
        <div>
          <h4 class="!text-[18px] text-gray-400 mb-1">Model/auto-update expiration (AUE) by OU</h4>
          <p class="text-sm text-gray-600">
            See an aggregate report of Chromebook models/Auto-update expiration (AUE) by OU.
          </p>
        </div>
        <div class="flex justify-end">
          <button
            class="!text-[14px] text-tertiary-blue-cta hover:bg-blue-50 border border-blue-600 rounded-md px-8 py-1 text-sm transition"
            type="button"
            (click)="openReport(reportTypes.MODEL_AUE)"
          >
            See Report
          </button>
        </div>
      </div>
    </div>

    <!-- Row 2 - Card 4 -->
    <div
      class="flex flex-row items-center border border-gray-300 rounded-lg bg-white p-4 gap-4 pl-0 dashboard-card shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-200 min-h-[calc(15vh-1.5rem)]"
    >
      <div class="report-icon-wrapper">
        <img src="images/reports/dual_laptop.svg" alt="Report 4" style="height: 90px !important; width: 90px !important;" class="report-icon" />
      </div>
      <div class="flex flex-col h-full w-full justify-between border-l border-gray-300 pl-4">
        <div>
          <h4 class="!text-[18px] text-gray-400 mb-1">15-day activity by OU</h4>
          <p class="text-sm text-gray-600">
           See an aggregate report of 15-day activity by organization unit.
          </p>
        </div>
        <div class="flex justify-end">
          <button
            class="!text-[14px] text-tertiary-blue-cta hover:bg-blue-50 border border-blue-600 rounded-md px-8 py-1 text-sm transition"
            type="button"
            (click)="openReport(reportTypes.FIFTEEN_DAY_ACTIVITY)"
          >
            See Report
          </button>
        </div>
      </div>
    </div>

    <!-- Row 2 - Card 5 -->
    <div
      class="flex flex-row items-center border border-gray-300 rounded-lg bg-white p-4 gap-4 pl-0 dashboard-card shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-200 min-h-[calc(15vh-1.5rem)]"
    >
      <div class="report-icon-wrapper">
        <img src="images/reports/chrome.svg" alt="Report 5" style="height: 70px !important; width: 70px !important;" class="report-icon" />
      </div>
      <div class="flex flex-col h-full w-full justify-between border-l border-gray-300 pl-4">
        <div>
          <h4 class="!text-[18px] text-gray-400 mb-1">Chrome Version Age by OU</h4>
          <p class="text-sm text-gray-600">
            See an aggregate report of major Chrome versions by organization unit.
          </p>
        </div>
        <div class="flex justify-end">
          <button
            class="!text-[14px] text-tertiary-blue-cta hover:bg-blue-50 border border-blue-600 rounded-md px-8 py-1 text-sm transition"
            type="button"
            (click)="openReport(reportTypes.CHROME_VERSION_AGE)"
          >
            See Report
          </button>
        </div>
      </div>
    </div>

    <!-- Row 2 - Card 6 -->
    <div
      class="flex flex-row items-center border border-gray-300 rounded-lg bg-white p-4 gap-4 pl-0 dashboard-card shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-200 min-h-[calc(15vh-1.5rem)]"
    >
      <div class="report-icon-wrapper">
        <img src="images/reports/battery.svg" alt="Report 6" style="height: 90px !important; width: 90px !important; transform: translateY(-50%) translateX(-6%);" class="report-icon" />
      </div>
      <div class="flex flex-col h-full w-full justify-between border-l border-gray-300 pl-4">
        <div>
          <h4 class="!text-[18px] text-gray-400 mb-1">Battery health by OU</h4>
          <p class="text-sm text-gray-600">
            See an aggregate report of battery health by organization unit.
          </p>
        </div>
        <div class="flex justify-end">
          <button
            class="!text-[14px] text-tertiary-blue-cta hover:bg-blue-50 border border-blue-600 rounded-md px-8 py-1 text-sm transition"
            type="button"
            (click)="openReport(reportTypes.BATTERY_HEALTH)"
          >
            See Report
          </button>
        </div>
      </div>
    </div>

    <!-- Row 3 - Card 7 -->
    <div
      class="flex flex-row items-center border border-gray-300 rounded-lg bg-white p-4 gap-4 pl-0 dashboard-card shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-200 min-h-[calc(15vh-1.5rem)]"
    >
      <div class="report-icon-wrapper" style="position: relative;">
        <img src="images/reports/storage_icon-2.svg" alt="Storage Background" style="height: 90px !important; width: 90px !important; position: absolute; top: 30%; left: 50%; transform: translate(-50%, -40%);" />
        <img src="images/reports/storage_icon-1.svg" alt="Storage Foreground" style="height: 65px !important; width: 65px !important; position: absolute; top: 80%; left: 30%; transform: translate(-40%, -56%);" class="report-icon" />
      </div>
      <div class="flex flex-col h-full w-full justify-between border-l border-gray-300 pl-4">
        <div>
          <h4 class="!text-[18px] text-gray-400 mb-1">Storage by OU</h4>
          <p class="text-sm text-gray-600">
            See critical, low, moderate, and high storage levels available by OU.
          </p>
        </div>
        <div class="flex justify-end">
          <button
            class="!text-[14px] text-tertiary-blue-cta hover:bg-blue-50 border border-blue-600 rounded-md px-8 py-1 text-sm transition"
            type="button"
            (click)="openReport(reportTypes.STORAGE_BY_OU)"
          >
            See Report
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
